<template>
  <section class="content">
    <div class="box box-info">
      <div class="p-toolbar p-component mb-4">
      <button class="p-button p-component p-button-help exportBtn" type="button" @click.prevent="exportCSV()" 
      v-if="this.expensesAccountLists.length > 0">
            <span class="pi pi-upload p-button-icon p-button-icon-left"></span><span class="p-button-label">Export</span>
            <span class="p-ink"></span>
      </button>


          <!-- <div class="p-toolbar p-component mb-4"> -->
            <expenseaccountdialog ref="openDialog"/>
        </div>
          
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
      
          <DataTable ref="po"
                     :value="expensesAccountLists"
                     :rowsPerPageOptions="[100,500,1000]" :paginator="true" :rows="100"
                     :filters="filters"
                     class="p-datatable-responsive p-datatable-gridlines"
          >
            <Column header="S.n">
              <template #body="slotProps">
                {{ slotProps.index + 1 }}
              </template>
            </Column>
            <Column :sortable="true" headerStyle="width: 16em"
                    header="Group"
                    field="accountHeadName"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['accountHeadName']"/>
              </template>
            </Column>
            <Column :sortable="true"
                    header="Sub Group"
                    field="accountSubHeadName"
                    filterField="accountSubHeadName"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['accountSubHeadName']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Name" field="name" filterMatchMode="contains">

              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['name']"/>
              </template>
            </Column>

            <Column :sortable="true"
                    header="Short Name"
                    field="shortName"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['shortName']"/>
              </template>
            </Column>

            <Column :sortable="true"
                    header="Opn Balance"
                    field="openingBalance"
                    filterMatchMode="contains"
                    bodyStyle="text-align: right"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['openingBalance']"/>
              </template>
            </Column>

            <Column :sortable="true"
                    header="Dr-Cr"
                    field="openingDrCr"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['openingDrCr']"/>
              </template>
            </Column>
            <Column :sortable="true"
                    header="Status"
                    field="status"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['status']"/>
              </template>
            </Column>
            <!-- <Column header="Action">
              <template #body="slotProps">
                <div class="container-fluid">
                  <div class="col-md-1">
                    <button  class="btn btn-success pull-right"  style="margin-right:5px"  @click="updateExpenseAccount(slotProps.data)">
                      <i class="fa fa-edit"/>
                    </button>
                    <button class="btn btn-danger"   @click="openDialog(slotProps.data.id)" >
                        <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                 </div>
              </template>
            </Column> -->
            <Column header="Action"  >
              <template #body="slotProps">


                <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                        @click="updateExpenseAccount(slotProps.data)"/>

                <Button icon="pi pi-trash" class="p-button-danger p-button-sm"
                        @click="openDialog(slotProps.data.id)"/>

              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteAccountMaster"/>
    </div>
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Dialog from '../../layout/dialog'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import globalKey from '../../../store/globalKey'
import Column from 'primevue/column'
import expenseaccountdialog from '../accountDialog/ExpenseAccountDialog.vue'
import Button from 'primevue/button'

export default {
  name: 'accountMaster',
  data() {
    return {
      dialogShow: false,
      columnList: '',
      filters: {},
      expenseAccountId: null
    }
  },
  computed: {
    expensesAccountLists() {
      return this.$store.state.accountMaster.expensesAccountLists
    }
  },
  mounted() {
    this.expensesMasterList()
    this.columnNames()
  },
  methods: {
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Supplier List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'supplierList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    async expensesMasterList() {
      await this.$store.dispatch('loadExpensesAccountList')
    },
    openDialog(data) {
      this.expenseAccountId = data
      this.dialogShow = true
    },
    cancel(data) {
      this.dialogShow = false
    },
    updateExpenseAccount(data) {
      this.$refs.openDialog.updateExpenseAccount(data)
    },
    closeDialog() {
      this.dialogShow = false
    },
    async deleteAccountMaster(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        accountMasterId: this.expenseAccountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteExpenseAccount', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
      this.closeDialog()
    }
  },
  components: {
    Dialog,
    Column,
    InputText,
    DataTable,
    expenseaccountdialog,
    Button
  }
}
</script>



// WEBPACK FOOTER //
// expensesAccount.vue?ba274c42